module.exports = __webpack_public_path__ + "c4d93c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/feedback/efremova.png
// module id = 3232
// module chunks = 21